export const TABLE_ROW_SELECTION: any = {
    mode: 'checkbox',
    bgColor: '#c9e7f7',
    hideSelectColumn: true,
    clickToSelect: true
}